import { Box, Divider, Icon, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { BiLogoJava, BiLogoPython } from 'react-icons/bi';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

import { PageHeader } from './widgets/PageHeader';

type Lang = 'python' | 'java';

const pmAPIs: { name: string; lang: Lang }[] = [
    { name: 'portfolio-optimizer', lang: 'python' },
    { name: 'portfolio', lang: 'java' },
    { name: 'rebalance', lang: 'java' },
    { name: 'pricing', lang: 'java' },
];

const externalAPIs: { name: string; lang: Lang }[] = [
    { name: 'auth', lang: 'java' },
    { name: 'billing', lang: 'java' },
    { name: 'broker-data', lang: 'java' },
    { name: 'client-gateway', lang: 'java' },
    { name: 'command-center-gateway', lang: 'java' },
    { name: 'core-optimization', lang: 'java' },
    { name: 'customer', lang: 'java' },
    { name: 'email', lang: 'java' },
    { name: 'encryption', lang: 'java' },
    { name: 'external-factors', lang: 'java' },
    { name: 'forecast-executor', lang: 'java' },
    { name: 'market-data', lang: 'java' },
    { name: 'ncrm', lang: 'java' },
    { name: 'reporting', lang: 'java' },
    { name: 'research-orchestrator', lang: 'java' },
];

export const Swagger = () => {
    return (
        <>
            <PageHeader title="Swagger docs" />
            <Tabs variant="solid-rounded" colorScheme="teal" isLazy orientation="vertical">
                <TabList flexShrink={0}>
                    {pmAPIs.map(({ name, lang }) => {
                        const icon = lang === 'python' ? BiLogoPython : BiLogoJava;
                        return (
                            <Tab key={name} textAlign="left" justifyContent="left">
                                <Icon boxSize={6} as={icon} mr={1} /> {name}
                            </Tab>
                        );
                    })}
                    <Divider my={4} />
                    {externalAPIs.map(({ name, lang }) => {
                        const icon = lang === 'python' ? BiLogoPython : BiLogoJava;
                        return (
                            <Tab key={name} textAlign="left" justifyContent="left">
                                <Icon boxSize={6} as={icon} mr={1} /> {name}
                            </Tab>
                        );
                    })}
                </TabList>
                <TabPanels>
                    {pmAPIs.map(({ name, lang }) => {
                        const specURL = lang === 'python' ? `/api/${name}/openapi.json` : `/api/${name}/v3/api-docs`;
                        return (
                            <TabPanel key={name} p={0}>
                                <Box background="white" px={8} py={4} borderRadius="md" maxW="1100px" mx="auto">
                                    <SwaggerUI url={specURL} withCredentials />
                                </Box>
                            </TabPanel>
                        );
                    })}
                    {externalAPIs.map(({ name, lang }) => {
                        const specURL = lang === 'python' ? `/api/${name}/openapi.json` : `/api/${name}/v3/api-docs`;
                        return (
                            <TabPanel key={name} p={0}>
                                <Box background="white" px={8} py={4} borderRadius="md" maxW="1100px" mx="auto">
                                    <SwaggerUI url={specURL} withCredentials />
                                </Box>
                            </TabPanel>
                        );
                    })}
                </TabPanels>
            </Tabs>
        </>
    );
};
